<template>
    <div class="cart-item">
        <div v-if="!isWMM"
             class="cart-item__remove"
             @click="removeProduct()">
            <svg width="24"
                 height="24"
                 viewBox="0 0 24 24"
                 fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <path d="M16.9498 8.46251L13.4143 11.998L16.9498 15.5336C17.1374 15.7211 17.2427 15.9755 17.2427 16.2407C17.2427 16.5059 17.1374 16.7603 16.9498 16.9478C16.7623 17.1353 16.5079 17.2407 16.2427 17.2407C15.9775 17.2407 15.7232 17.1353 15.5356 16.9478L12.0001 13.4123L8.46455 16.9478C8.27701 17.1353 8.02266 17.2407 7.75744 17.2407C7.49222 17.2407 7.23787 17.1353 7.05033 16.9478C6.8628 16.7603 6.75744 16.5059 6.75744 16.2407C6.75744 15.9755 6.8628 15.7211 7.05033 15.5336L10.5859 11.998L7.05033 8.46251C6.8628 8.27498 6.75744 8.02062 6.75744 7.75541C6.75744 7.49019 6.8628 7.23584 7.05033 7.0483C7.23787 6.86076 7.49222 6.75541 7.75744 6.75541C8.02266 6.75541 8.27701 6.86076 8.46455 7.0483L12.0001 10.5838L15.5356 7.0483C15.7232 6.86076 15.9775 6.75541 16.2427 6.75541C16.5079 6.75541 16.7623 6.86076 16.9498 7.0483C17.1374 7.23584 17.2427 7.49019 17.2427 7.75541C17.2427 8.02062 17.1374 8.27498 16.9498 8.46251Z"
                      fill="#7019FD" />
            </svg>
        </div>

        <div class="cart-item__image">
            <img v-if="!!item.image || !!item.product.image"
                 :src="item.image || item.product.image"
                 alt="">
            <img v-else
                 src="@/assets/img/menus/pic1.jpg"
                 alt="">
        </div>
        <div class="cart-item__info">
            <h6>{{ item.product.name }}</h6>
            <ul v-if="item.subproducts"
                class="cart-item__info__subproducts">
                <li v-for="subproduct in item.subproducts"
                    :key="subproduct.id">
                    <div>
                        <span class="cart-item__info__subproducts__quantity">
                            {{ `+ ${getItemQuantity(subproduct)} x` }}
                        </span>
                        &nbsp; {{ `${subproduct.product.name} (${getFormattedItemPrice(subproduct,
                            { includeSubItems: false })})` }}
                    </div>
                </li>
            </ul>
            <div class="cart-item__info__footer">
                <div class="cart-item__info__footer__price">{{ getFormattedItemPrice(item) }}
                </div>
                <template v-if="!isWMM">
                    <VItemCounter class="cart-item__info__footer__counter"
                                  :id="item.id"
                                  :value="getItemQuantity(item)"
                                  @update:value="updateItemQuantity" />
                </template>
                <template v-else>
                    <div class="cart-item__info__footer__quantity">{{ `${getItemQuantity(item)} x` }}</div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import VItemCounter from "@/components/ui/VItemCounter.vue";
import { getItemQuantity, getFormattedItemPrice } from "@/utils/itemHelper";

export default {
    name: "CartItem",
    components: {
        VItemCounter
    },
    data() {
        return {};
    },
    props: {
        item: { type: Object, required: true }
    },
    computed: {
        isWMM() {
            return this.$store.getters['getIsModeWMM'];
        }
    },
    methods: {
        removeProduct() {
            this.$store.dispatch('cartStore/REMOVE_ITEM_FROM_CART', this.item.uid);
        },
        getItemQuantity(item) {
            return getItemQuantity(item);
        },
        getFormattedItemPrice(item, obj) {
            return getFormattedItemPrice(item, obj);
        },
        updateItemQuantity(quantity) {
            this.$store.dispatch('cartStore/UPDATE_ITEM_QUANTITY', { uid: this.item.uid, quantity });
        },
    }
};
</script>

<style lang="scss" scoped>
ul,
li {
    margin: 0;
    padding: 0;
    list-style: none;
}

h6 {
    margin: 0;
    padding: 0;

    font: {
        size: 16px;
        weight: 700;
    }

    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
}

.cart-item {
    border-bottom: 1px solid #E6E6E6;
    padding-bottom: 10px;
    position: relative;

    display: flex;

    &__remove {
        position: absolute;
        right: 0;
        top: 0;

        cursor: pointer;
    }

    &__image {
        width: 110px;
        height: 110px;

        &>img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 8px;
        }
    }

    &__info {
        flex: 1;
        padding-left: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-self: stretch;
        gap: 5px;

        &__subproducts {
            &__quantity {
                color: #7019FD;
            }
        }

        &__footer {
            display: flex;
            align-items: center;
            gap: 12px;

            &__price,
            &__quantity {
                font-weight: 700;
                font-size: 16px;

                color: black;
            }

            &__counter,
            &__quantity {
                margin-left: auto;
            }
        }

    }
}

.cart_item {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 16px;
    justify-content: space-between;
}

.cart_item-image {
    width: 64px;
    height: 64px;
    border-radius: 8px;
    overflow: hidden;
}

.cart_item-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.cart_item-description {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.cart_item-description h6 {
    margin: 0;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
}
</style>